import { Film, Image as ImageIcon } from "lucide-react";

export const ASPECT_CLASS = {
  "16:9": "aspect-video",
  "1:1": "aspect-square",
  "9:16": "aspect-[9/16]",
  "4:5": "aspect-[4/5]",
  "4:3": "aspect-[4/3]",
  "16:10": "aspect-[16/10]",
  "21:9": "aspect-[21/9]",
};

export const Placeholder = ({ ph }) => {
  const Icon = ph.kind === "video" ? Film : ImageIcon;
  return (
    <div className={`ph-grid relative w-full ${ASPECT_CLASS[ph.aspect] || "aspect-video"} rounded-2xl md:rounded-3xl border border-[#1C1C1C]/10 bg-[#EDE9E2] overflow-hidden flex items-center justify-center transition-colors duration-300 hover:border-[#FF5E3A]/40`} data-testid="cs-placeholder">
      <span className="absolute top-3 left-3 md:top-5 md:left-5 text-[9px] md:text-[10px] font-bold uppercase tracking-[0.2em] text-[#FF5E3A] bg-[#FF5E3A]/10 px-2.5 py-1 md:px-3 md:py-1.5 rounded-full">To be created</span>
      <div className="text-center px-4">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#1C1C1C]/5 flex items-center justify-center mx-auto mb-3 md:mb-4">
          <Icon size={18} className="text-[#FF5E3A]" />
        </div>
        <p className="text-xs md:text-sm font-bold uppercase tracking-[0.15em] text-[#1C1C1C]/70">{ph.format}</p>
        <p className="text-[11px] md:text-sm text-[#1C1C1C]/40 mt-1 font-medium">{ph.dims}</p>
      </div>
      <span className="absolute bottom-3 right-3 md:bottom-5 md:right-5 text-[9px] md:text-[10px] font-bold text-[#1C1C1C]/30 tracking-widest border border-[#1C1C1C]/15 px-2 py-0.5 md:px-2.5 md:py-1 rounded-full">{ph.aspect}</span>
    </div>
  );
};
